export default __webpack_public_path__ + "static/media/logo.c5c4397f.png";